import React from 'react';
import { useAppSelector } from '../../state/hooks';
import { ConsumerJourneyMapStyles } from './styles';
import {
  ConsumerJourneyMapAbout,
  ConsumerJourneyMapBenefit,
  ConsumerJourneyMapDiscover,
  ConsumerJourneyMapExperience,
  ConsumerJourneyMapExperts,
  ConsumerJourneyMapIntro,
  ConsumerJourneyMapMap,
  ConsumerJourneyMapSlider,
  ConsumerJourneyMapSolution,
  ConsumerJourneyMapTrustedBy,
} from '../../components';
import MetaFromApi from '../../components/metaFromApi/MetaFromApi';

export const ConsumerJourneyMap = () => {
  const { interfaceLanguage } = useAppSelector((state) => state.languages);

  return (
    <ConsumerJourneyMapStyles>
      <MetaFromApi slug="consumer-journey-map" />
      <ConsumerJourneyMapIntro />
      <ConsumerJourneyMapAbout />
      <ConsumerJourneyMapExperience />
      <ConsumerJourneyMapDiscover />
      <ConsumerJourneyMapMap />
      <ConsumerJourneyMapExperts />
      <ConsumerJourneyMapSlider />
      <ConsumerJourneyMapBenefit />
      <ConsumerJourneyMapSolution />
      <ConsumerJourneyMapTrustedBy />
    </ConsumerJourneyMapStyles>
  );
};
